import React, {Component} from "react";

import "./GameCard.component.scss";
import {Game} from "../../../reducers/games.reducer";
import {checkPermission} from "./../../../../../utils/Authorization/authorization";
import {Link} from "react-router-dom";

export interface GamesCardProps {
    game: Game;
    edit: any;
    onClick: any;
}

class GameCard extends Component<GamesCardProps> {
    clickedGame = () => {
        if (
            this.props.game.id !== 500 &&
            checkPermission("list_game_configs")
        ) {
            this.props.onClick(`/games/game/${this.props.game.id}`);
        }
    };

    clickEdit = e => {
        e.stopPropagation();
        const {game, edit} = this.props;
        edit(game);
    };

    render() {
        const {game, edit} = this.props;
        const game_types_name = ["Bingo", "Spins", "Lotto", "Keno"]
        return (
            <div className="info-card games active" key={"info-card" + game.id}>
                <Link to={`/games/game/${this.props.game.id}`}>
                    <div
                        onClick={this.clickedGame}
                        className="game-card-image-header"
                        style={{
                            backgroundImage: `url("${window.location.protocol}//${window.location.hostname}${game.image}")`
                        }}
                    />
                    <div className="game-card-content" onClick={this.clickedGame}>
                        <div className="game-id-edit">
                            <div className="game-id-tag" onClick={this.clickedGame}>
                                ID {game.id}
                            </div>
                            {game.deprecated && (
                                <span className="game-deprecated">Deprecated</span>
                            )}
                        </div>
                        <div className="game-card-header">
                            <div>
                                <div>{game.name}</div>
                                {game.id !== 500 && (
                                    <div className="game_version">
                                        {game.type !== null
                                            ? game_types_name[game.type]
                                            : "-"}{" "}
                                        /{" "}
                                        {game.software_house
                                            ? game.software_house.id == 2
                                                ? "FBM Brasil"
                                                : "Fabamaq"
                                            : "-"}
                                    </div>
                                )}
                                <ul className="game-attr-list">
                                    <li className="game-attr-list-li-full">
                                        <p><span>Trademark:</span> {game.trademark ? game.trademark.name : '-'}</p>
                                    </li>
                                </ul>

                                <ul className="game-attr-list">
                                    <li>
                                        <span>Client:</span>
                                        <p>{game.client ? game.client.name : '-'}</p>
                                    </li>
                                    <li>
                                        <span>Feature:</span>
                                        <p>{game.feature ? game.feature.name : '-'}</p>
                                    </li>
                                    <li>
                                        <span>Platform:</span>
                                        <p>{game.platform ? game.platform.name : '-'}</p>
                                    </li>
                                    <li>
                                        <span>Series:</span>
                                        <p>{game.series ? game.series.name : '-'}</p>
                                    </li>
                                    <li>
                                        <span>Product Type:</span>
                                        <p>{game.game_type ? game.game_type.name : '-'}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </Link>
                <div className="game-card-footer">
                    {(process.env.REACT_APP_BUILD_ENV === "PROD" || !process.env.REACT_APP_BUILD_ENV) && checkPermission("edit_games") && game.id !== 500 && (
                        <button
                            className="edit-game-button"
                            onClick={this.clickEdit}
                        >
                            Edit
                        </button>
                    )}
                </div>
            </div>
        );
    }
}

export default GameCard;
